// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__teg0z","disabled":"checkbox_disabled__Ge5sD","error":"checkbox_error__ByBmo"};